import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { userId } from '../../../reducers/currentUser/currentUser.reducer';
import { loadForAdmin, sortByDate, sortByProjectName } from '../../../reducers/workOrder/workOrders.actions';
import { loading, projectWorkOrders } from '../../../reducers/workOrder/workOrders.reducer';
import { Spinner } from '../../Spinner/Spinner';
import WorkOrderList from '../../WorkOrderList/WorkOrderList';
import './AdminHome.css';

// eslint-disable-next-line object-curly-newline
export class AdminHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = { type: '' };
  }

  componentDidMount() {
    this.props.load();
  }

  componentDidUpdate() {
    if (this.props.match.params.type !== this.state.type) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ type: this.props.match.params.type });
      this.props.load();
    }
  }

  render() {
    return (
      <span>
        <Button onClick={() => this.props.sortDate()}>Sort Date</Button> &nbsp;&nbsp;&nbsp;
        <Button onClick={() => this.props.sortProject()}>Sort Project</Button>
        <LinkContainer to="/admin/workorders/new" >
          <Button className="pull-right" bsStyle="primary" >Create New DWR</Button>
        </LinkContainer>
        <br />
        {this.props.loading && <Spinner isLoading /> }
        {
          this.props.workOrders.map(w => (
            <WorkOrderList workOrders={w} url="/admin" />
          ))
        }
      </span>
    );
  }
}

AdminHome.propTypes = {
  load: PropTypes.func.isRequired,
  sortDate: PropTypes.func.isRequired,
  sortProject: PropTypes.func.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ type: PropTypes.shape({}) }) }).isRequired,
  workOrders: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  loading: PropTypes.bool.isRequired,
};

export const mapStateToProps = state => ({
  workOrders: projectWorkOrders(state),
  loading: loading(state),
  id: userId(state),
});

export const mapDispatchToProps = (dispatch, ownProps) => {
  const dwrTypes = ownProps.match.params.type;

  return ({
    load: () => dispatch(loadForAdmin(dwrTypes)),
    sortDate: () => dispatch(sortByDate()),
    sortProject: () => dispatch(sortByProjectName()),
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminHome);



// WEBPACK FOOTER //
// ./src/components/Admin/Home/AdminHome.jsx